<template>
    <div class="top">
      <van-nav-bar
        :title="title"
        @click-left="onClickLeft"
        :style="{background:color}"
        >
        <template #left>
            <van-icon name="arrow-left" size="24" />
        </template>
         <template #right v-if="buttonId!=4283">
            <van-icon name="wap-home-o" size="24" @click="goHome" />
            <!-- <img style="width:20px" @click="goHome" src="@/assets/images/icon_home.png"/> -->
            <span style="margin-left: 3px;color: #fff;" @click="goHome">返回首页</span>
        </template>
      </van-nav-bar>
        
    </div>
</template>
<script>
export default {
    props:{
        title:{
            type:String,
            default:''
        },
        color:{
            type:String,
            default:''
        },
        buttonId:{
            type:String|Number,
            default:0
        }
    },
      data(){
        return{
            path:'/vascularNews/meeting/index',
            meeting_id:this.$route.query.meeting_id,
        }
    },
    mounted(){
        this.routerName=this.$route.name;
        if(this.meeting_id){
        }
        else{
            this.meeting_id=this.$route.query.id?this.$route.query.id:this.$route.query.MT_id;
        }
        if(this.meeting_id==286){
            this.path="/cec2022/index";
        }
        else if(this.meeting_id==348){
            this.path="/cec2023/index";
        }
        else if(this.meeting_id==399){
            this.path='/CVSCF2023/index'
        }
        else if(this.meeting_id==483){
            this.path='/XVC/index'
        }
        if(this.routerName=='ExpertIndex'){
            if(this.meeting_id){
            }
            else{
                this.path='/vascularNews'
            }
        }

        
    },
    methods:{
        onClickLeft(){
            this.$router.go(-1)
        },
        goHome(){
            this.$router.push({
                path:this.path,
                query:{
                    meeting_id:this.meeting_id
                }
            })
        },
        goCalendar(){
            this.$router.push({
                path:'/vascularnews/calendar'
            })
        }
    }
    
  
}
</script>
<style lang="scss" scoped>
.van-nav-bar{
    // background: #901D22;
    .van-icon{
        color: white;
    }
}
 .van-nav-bar /deep/.van-nav-bar__title{
    color: white;
    font-size: 16px;
    letter-spacing: 0.5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Top.vue